// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__YaXe9","title":"ClientInsurance_title__PQaBA","itemText":"ClientInsurance_itemText__2dbxL"};